<template>
  <div>
    <vx-card title="Товар" class="p-6">
      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Название"
        name="Название"
        v-model="dish.name"
      />
      <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Описание"
        name="Описание"
        v-model="dish.description"
      />
      <span class="text-danger text-sm">{{ errors.first("Описание") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Цена, руб."
        name="Цена"
        type="number"
        v-model.number="dish.price"
      />
      <span class="text-danger text-sm">{{ errors.first("Цена") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Вес, кг."
        name="Вес"
        type="number"
        v-model.number="dish.weight"
      />
      <span class="text-danger text-sm">{{ errors.first("Вес") }}</span>

      <picture-input
        ref="pictureInput"
        class="mt-10 z-10"
        @change="onChange"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :prefill="dish.image"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>

      <vs-button
        @click="updateDish"
        :disabled="!validateForm"
        class="mr-5 vs-con-loading__container"
        ref="loadableButton"
        type="relief"
      >
        Обновить
      </vs-button>

      <vs-button
        @click="deleteDish"
        class="vs-con-loading__container"
        ref="loadableButton"
        type="relief"
        color="danger"
      >
        Удалить
      </vs-button>
    </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";
import PictureInput from "vue-picture-input";

export default {
  data: () => ({
    BASE_URL: API_URL,
    dish: [],
  }),
  components: {
    PictureInput,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.dish.name !== "" &&
        this.dish.description !== "" &&
        this.dish.price !== "" &&
        this.dish.weight !== ""
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    onChange() {
      let payload = {
        imageFile: this.$refs.pictureInput.file,
      };

      this.uploadImage(payload);
    },
    uploadImage(data) {
      try {
        this.$load(async () => {
          let res = await this.$api.cafe.updateImageProduct(
            this.$route.params.id,
            data
          );

          this.notification(
            "Успешно",
            "Изображение успешно обновлено",
            "success"
          );
        });
      } catch (error) {
        this.notification(
          "Ошибка",
          "Не удалось обновить изображение",
          "danger"
        );
      }
    },
    getDish() {
      this.$load(async () => {
        let res = (await this.$api.cafe.getDish(this.$route.params.id)).data;

        res.image = res.image !== null ? this.BASE_URL + res.image : null;

        this.dish = res;
      });
    },
    updateDish() {
      let payload = {
        name: this.dish.name,
        description: this.dish.description,
        price: this.dish.price,
        weight: this.dish.weight,
      };

      try {
        this.$load(async () => {
          let res = await this.$api.cafe.updateDish(
            this.$route.params.id,
            payload
          );
        });
        this.notification("Успешно", "Блюдо обновлено", "success");
      } catch (error) {
        this.notification("Ошибка", "Не удалось обновить блюдо", "danger");
      }
    },
    deleteDish() {
      try {
        this.$load(async () => {
          let res = (await this.$api.cafe.deleteDish(this.$route.params.id))
            .data;
          this.notification("Успешно", "Блюдо удалено", "success");
          this.$router.push({ name: "cafe-dishes" });
        });
      } catch (error) {
        this.notification("Ошибка", "Не удалось удалить блюдо", "danger");
      }
    },
  },
  created() {},
  mounted() {
    this.getDish();
  },
};
</script>